import * as PACKAGE from './package.json';
import IconSvg from './src/atom/icon-svg';

// 存储组件列表
const components = [
    IconSvg,
];


const install = function (Vue) {
    if (install.installed) return;
    components.forEach(component => {
        Vue.component(component.name, component);
    });
};


if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default  {
    version: PACKAGE.version,
    install,
    ...components,
};
